import { useState, type ReactNode } from "react";
import { LiveDot } from "./ui";

type Tab = { id: string; label: string; content: ReactNode };

export function PromptTerminal({ url, tabs, live, footer }: { url: string; tabs: Tab[]; live?: boolean; footer?: ReactNode }) {
  const [active, setActive] = useState(tabs[0]?.id);
  const current = tabs.find((t) => t.id === active) ?? tabs[0];
  return (
    <div className="term hud">
      <div className="term-bar">
        <div className="term-dots">
          <i />
          <i />
          <i />
        </div>
        <div className="term-url">{url}</div>
        {live !== undefined && <LiveDot live={live} label={live ? "LIVE" : "IDLE"} />}
      </div>
      <div className="term-screen">
        {tabs.length > 1 && (
          <div className="term-tabs" role="tablist">
            {tabs.map((t) => (
              <button key={t.id} role="tab" aria-selected={t.id === current?.id} onClick={() => setActive(t.id)}>
                {t.label}
              </button>
            ))}
          </div>
        )}
        <div className="term-body">{current?.content}</div>
      </div>
      {footer && <div className="panel-pad small" style={{ borderTop: "1px solid var(--line-strong)" }}>{footer}</div>}
    </div>
  );
}
